<template>
    <customModal :containermd="true" :bodysm="true" @closeModal="closeFormModal()">
         <template #title>
            {{ $t("navigations.forms") }}
        </template>
        <template #body>
            <div class="form-group row my-lg-2">
                <div class="d-flex flex-column flex-lg-row mb-lg-0">
                    <div class="col-lg-12">
                    <table class="table features-table">
                    <p v-if="!soAItem.eCRF || soAItem.eCRF.length === 0" class="mb-0 text-center">
                        {{ $t("navigations.no forms added") }}
                    </p>
                    <tbody>
                        <tr v-for="(form, index) in soAItem.eCRF" :key="index">
                        <td>{{ form.templateName }} ({{ form.version }})</td>
                        <td class="text-center">
                            <i class="fa fa-eye edit-delete" @click.prevent="gotoform(form.templateId)"></i>
                        </td>
                        </tr>
                    </tbody>
                    </table>

                    </div>
                </div>
            </div>
        </template>
    </customModal>
    <showformmodel
        v-if="setshowActivityFormModal"
        :formid="currentform"
        currentformstatus="not completed"
        @closeformModal="closeformActivityModal()"
    />
</template>

<script src="./StudyActivityForms.js"></script>